module.exports = __webpack_public_path__ + "svg/flags/Saint Helena, Ascension and Tristan da Cunha.svg";